"use client"
const Photo = require("../../../assets/waiting-order.webp")
import { ChartNoAxesCombined, Lightbulb, Settings, SignalHigh } from "lucide-react"

import Image from "next/image"
import { useRouter } from "next/navigation"
import SimpleModal from "./BaseModal"

type Props = {
   isOpen: boolean
   onClose: () => void
}

const ExitIntent = ({ isOpen, onClose }: Props) => {
   const route = useRouter()

   const handleClaimResource = () => {
      route.push("/unified/signup?resource=The-Impact-of-Effective-Scheduling-in-the-Workplace")
   }

   return (
      <SimpleModal isOpen={isOpen} onClose={onClose} classname="!p-0 max-h-[85vh] ">
         <div className="flex flex-col shadow md:flex-row">
            <div className="relative hidden h-64 min-h-[250px] md:flex md:h-auto md:max-w-[40%]">
               <Image src={Photo} alt="Restaurant Guide" className="h-full rounded-l-lg object-cover object-center" />
            </div>
            <div className="flex flex-col p-4 md:max-w-[60%]">
               <h2 className={`mb-3 pr-8 text-xl font-bold text-gray-700 md:text-3xl`}>
                  Unlock Your <br /> Restaurant&apos;s Potential
               </h2>
               <h3 className="text-md mb-4 text-gray-600">
                  Get our exclusive free guide packed with expert tips, strategies, and insights to help your restaurant
                  thrive in today&apos;s market.
               </h3>
               <div className="flex flex-col gap-3 rounded-lg bg-orange-50 p-5">
                  <div className="flex items-start gap-2 md:items-center">
                     <span className="flex items-start md:items-center">
                        <SignalHigh
                           size={25}
                           className="!align-baseline"
                           style={{ display: "inline-block", verticalAlign: "baseline", marginBottom: "-2px" }}
                        />
                     </span>
                     <h3 className="text-sm leading-none">In-depth industry analysis & emerging trends</h3>
                  </div>

                  <div className="flex items-start gap-2 md:items-center">
                     <span className="flex items-start md:items-center">
                        <ChartNoAxesCombined
                           size={25}
                           className="!align-baseline"
                           style={{ display: "inline-block", verticalAlign: "baseline", marginBottom: "-2px" }}
                        />
                     </span>
                     <h3 className="text-sm leading-none">Proven marketing & growth strategies</h3>
                  </div>

                  <div className="flex items-start gap-2 md:items-center">
                     <span className="flex items-start md:items-center">
                        <Settings
                           size={25}
                           className="!align-baseline"
                           style={{ display: "inline-block", verticalAlign: "baseline", marginBottom: "-2px" }}
                        />
                     </span>
                     <h3 className="text-sm leading-none">Operational tips for efficiency</h3>
                  </div>

                  <div className="flex items-start gap-2 md:items-center">
                     <span className="flex items-start md:items-center">
                        <Lightbulb
                           size={25}
                           className="!align-baseline"
                           style={{ display: "inline-block", verticalAlign: "baseline", marginBottom: "-2px" }}
                        />
                     </span>
                     <h3 className="text-sm leading-none">Expert insights & guidance</h3>
                  </div>
               </div>
               <div className="mt-4 flex w-full flex-col gap-2">
                  <button
                     className="rounded bg-orange-500 px-4 py-2 text-white transition-colors hover:bg-orange-600"
                     onClick={handleClaimResource}
                  >
                     Claim Your Resource
                  </button>
               </div>
            </div>
         </div>
      </SimpleModal>
   )
}

export default ExitIntent
